import React, { useState, useEffect } from "react";
import axios from "axios";
import NavbarComponent from "./NavbarComponent";
import Footer from "./Footer";
import API_URLS from "./apiConfig";
import { useParams } from "react-router-dom";

const InvestorsFaq = () => {
  const [title, setTitle] = useState("Investors FAQs"); // Default title
  const [faqs, setFaqs] = useState([]); 
  const [openFaq, setOpenFaq] = useState(null);
  const [error, setError] = useState(null); 

  const { id } = useParams();
  const { pagename } = useParams();
  const defaultlang = API_URLS.defaultLang;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(API_URLS.getAllDetails+`/${pagename}/${id}/${defaultlang}`);
        if (response.data) {
          const { title, faq_repeater } = response.data;

          setTitle(title);
          setFaqs(faq_repeater || []);
        } else {
          throw new Error("Unexpected API response structure.");
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load FAQs. Please try again later.");
      }
    };

    fetchData();
  }, [pagename, id, defaultlang]);

  const toggleFaq = (index) => {
    setOpenFaq((prev) => (prev === index ? null : index));
  };

  return (
    <>
      <NavbarComponent />
      <div className="modules-container investor-faq-container">
        <div className="container">
          <h1 className="universal-header">{title}</h1>
          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <div className="modules-list">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`module-item ${openFaq === index ? "active" : ""}`}
                >
                  <div
                    className="module-header"
                    onClick={() => toggleFaq(index)}
                  >
                    <span>{faq.title}</span>
                    <span className="toggle-icon">
                      {openFaq === index ? "-" : "+"}
                    </span>
                  </div>
                  {openFaq === index && (
                    <div className="module-content">
                      <div dangerouslySetInnerHTML={{ __html: faq.description }} />
                    </div>  
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default InvestorsFaq;
